define('collections/transactions',['require','collections/base','models/transaction'],function(require){

    var BaseCollection = require('collections/base');
    var Model = require("models/transaction");

    return BaseCollection.extend({
        model: Model,
        url: 'transactions.json'
    });
});

